import Http from '@rrc/http'
import {
  GATEWAYPREFIX
} from '@/config/global.config'
const prefix = GATEWAYPREFIX.reinstall

/**
 * 获取门店列表 （自建车入库存调用）
 * @param {Number} work_order_id 工单ID
 * @returns data
 */
export function getWellChoosenShopList(params) {
  return Http.get(`${prefix}/v1/wellchosen/get_well_chosen_shop`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 自建车提交入库
 * @param {Number} work_order_id
 * @param {Number} car_id
 * @param {Number} source 车辆来源
 * @param {Number} contract_type 合同类型
 * @param {Number} shop_id
 * @param {String} city
 * @returns data
 */
export function commitWellChoosen(params) {
  return Http.post(`${prefix}/stock/car/v1/commit_stock_info`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 查询库存列表
 * @param {Number} status
 * @returns data
 */
export function getStockList(params) {
  return Http.get(`${prefix}/stock/app/stock_list/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 查询车辆是否已经收车过户
 * @param {Number} status
 * @returns data
 */
 export function getStockTransferStatus(params) {
  return Http.get(`${prefix}/stock/app/query_transfer_status`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}


/**
 * 联系车主
 * @param {Number} car_id 车源ID 4
 * @returns data
 */
export function contactCarOwner(params) {
  return Http.get(`${prefix}/stock/axb/number`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 根据车牌号或车源编号获取库存列表 3
 * @param {Number} car_number
 * @returns data
 */
export function getStockListByCarNumber(params) {
  return Http.get(`${prefix}/stock/app/get_stock/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 入库-获取入库清单中车辆信息 5
 * @param {String} car_id 车源编号
 * @returns data
 */
export function getInStockCarInfo(params) {
  return Http.get(`${prefix}/stock/app/stock_car_info/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 入库-获取入库清单中车辆信息 5
 * @param {String} car_id 车源编号
 * @returns data
 */
 export function getInStockCarInfoV2 (params) {
  return Http.get(`${prefix}/stock/app/stock_car_info/v2`, params, { isAutoMsg: true, isLoading: true })
}

/**
 * 入库-提交入库清单 6
 * @param {String} car_id 车源编号
 * @returns data
 */
export function submitInStockCarInfo(params) {
  return Http.post(`${prefix}/stock/app/stock_details/commit/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 入库-提交入库清单 6
 * @param {String} car_id 车源编号
 * @returns data
 */
 export function submitInStockCarInfoV2 (params) {
  return Http.post(`${prefix}/stock/app/stock_details/commit/v2`, params, { isAutoMsg: true, isLoading: true })
}

/**
 * 根据库存单号查询库存详情 12
 * @param {Number} car_id 车辆ID
 * @returns data
 */
export function getStockDetail(params) {
  return Http.get(`${prefix}/stock/app/stock_detail/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 根据库存单号查询库存详情 12
 * @param {Number} car_id 车辆ID
 * @returns data
 */
 export function getStockDetailV2(params) {
  return Http.get(`${prefix}/stock/app/stock_detail/v2`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 获取车牌号
 * @param {Number} car_id 车源编号
 * @param {Number} source 查询来源 H5端默认为10
 * @return {Number} plate_number 车牌号
 */
export function getCarplateNumber(params) {
  params.source = 10 // H5端默认为10
  return Http.get(`${prefix}/stock/other/sensitive_information/plate_number`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 更新库存信息 13
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
export function updateStockDetail(params) {
  return Http.post(`${prefix}/stock/app/update_stock_detail/v1`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 更新库存信息V2
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
 export function updateStockDetailV2 (params) {
  return Http.post(`${prefix}/stock/app/update_stock_detail/v2`, params, { isAutoMsg: true, isLoading: false })
}

/**
 * 获取入库清单 （进入出库页面时调用）7
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
export function getInStockDetail(params) {
  return Http.get(`${prefix}/stock/app/stock_details/v1`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * APP-出库单出库前查看相关信息接口
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
 export function getInStockDetailV2 (params) {
  return Http.get(`${prefix}/stock/app/stock_details/v2`, params, { isAutoMsg: true, isLoading: false })
}

/**
 * APP-出库单出库前查看相关信息接口
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
export function getInStockDetailV3 (params) {
  return Http.get(`${prefix}/stock/app/stock_details/v3`, params, { isAutoMsg: true, isLoading: false })
}


/**
 * 在库出库-提交出库清单 8
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @return {Object} data
 */
export function submitOutStockCarInfo(params) {
  return Http.post(`${prefix}/stock/app/leave_stock/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 在库出库-提交出库清单 8
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @return {Object} data
 */
 export function submitOutStockCarInfoV2 (params) {
  return Http.post(`${prefix}/stock/app/leave_stock/v2`, params, { isAutoMsg: true, isLoading: true })
}

/**
 * 在库出库-提交出库清单 8
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @return {Object} data
 */
export function submitOutStockCarInfoV3 (params) {
  return Http.post(`${prefix}/stock/app/leave_stock/v3`, params, { isAutoMsg: true, isLoading: true })
}

/**
 * 暂出库出库(暂出库状态下的车可以直接出库) 11
 * @param {Number} stock_id 库存编号
 * @returns data
 */
export function submitOutDirectly(params) {
  return Http.post(`${prefix}/stock/app/temporary_leave/leave_stock/v1`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 获取出库清单 （进入回库页面时调用）9
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @return {Object} data
 */
export function getBackStockDetail(params) {
  return Http.get(`${prefix}/stock/app/stock_delivery_details/v1`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 获取出库清单 （进入回库页面时调用）9
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @return {Object} data
 */
 export function getBackStockDetailV2 (params) {
  return Http.get(`${prefix}/stock/app/stock_delivery_details/v2`, params, { isAutoMsg: true, isLoading: false })
}

/**
 * 暂出库回库 10
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @returns data
 */
export function submitBackStockCarInfo(params) {
  return Http.post(`${prefix}/stock/app/back_stock/v1`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 暂出库回库 10
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @returns data
 */
 export function submitBackStockCarInfoV2 (params) {
  return Http.post(`${prefix}/stock/app/back_stock/v2`, params, { isAutoMsg: true, isLoading: false })
}

/**
 * 查看库存记录 14
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
export function getRecordList(params) {
  return Http.get(`${prefix}/stock/app/stock_history/v1`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 获取整备列表 15
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
export function getServiceList(params) {
  return Http.get(`${prefix}/stock/app/servicing/getList`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 获取所有整备项列表 16 （初次整备的时候才会调用这个接口）
 * @param {Number} stock_id 车源编号
 * @return {Object} data
 */
export function getFirstServiceProjectList(params) {
  return Http.get(`${prefix}/stock/app/servicing/getProjectList`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 获取整备项 17
 * @param {Number} stock_id 车源编号 第一次的时候传0 之后根据选项传值 每次返回的数据不同
 * @return {Object} data
 */
export function getServiceProjectList(params) {
  return Http.get(`${prefix}/stock/app/servicing/get_project`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 提交整备 18
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @param {Number} servicing_type 整备类型
 * @param {Number} servicing_category 类别
 * @param {Number} servicing_project 项目
 * @param {Number} payment 金额
 * @param {Number} img_id 图片ID
 * @returns data
 */
export function submitService(params) {
  return Http.post(`${prefix}/stock/app/servicing/commit`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 编辑整备 19
 * @param {Number} id 整备ID
 * @param {Number} payment 金额
 * @param {Number} img_id 图片ID 非必填
 * @returns data
 */
export function editService(params) {
  return Http.post(`${prefix}/stock/app/servicing/update`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * H5批量提交整备 补充接口8
 * @param {Number} stock_id 车源编号
 * @param {Number} car_id 车辆ID
 * @param {Number} servicing_type 整备类型
 * @param {Number} servicing_category 类别
 * @param {Number} servicing_project 项目
 * @param {Number} payment 金额
 * @param {Number} img_id 图片ID
 * @returns data
 */
export function batchSubmitService(params) {
  return Http.post(`${prefix}/stock/app/servicing/batch/commit`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 补充接口2 获取库存状态列表(不用了)
 * @returns status_lsit
 */
export function getStockStatusList(params) {
  return Http.get(`${prefix}/stock/app/other/get_stock_status_list`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 补充接口9 获取车辆来源
 * @returns car_source_lsit
 */
export function getCarSourceList(params) {
  return Http.get(`${prefix}/stock/other/get_car_source`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 获取出库类型
 * @returns list
 */
export function getExitStockType(params = {}) {
  return Http.get(`${prefix}/stock/other/get_exit_stock_type`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

// 获取拍摄列表各状态数量
export function getPhotoStatusList(params, id) {
  return Http.post(`${prefix}/photo/task/app/get/list_status_statistics${id ? `?id=${id}` : ''}`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

// 获取拍摄状态列表
export function getPhotoList(params = {}) {
  return Http.post(`${prefix}/photo/task/v2/app/get/list`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

// 获取转单人员列表
export function getInspectorsList(params) {
  return Http.get(`${prefix}/photo/task/app/get_transfer/members`, params, {
    isAutoMsg: true,
    isLoading: false
  })
}

/**
 * 照片更新 转单
 * @param {number} photo_work_order_id 拍摄工单ID
 * @param {number} receive_user_id 接收者userid
 * @returns ok
 */
export function transfer(params) {
  return Http.post(`${prefix}/photo/task/app/transfer`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

// 获取拍摄工单详情
export function getPhotoOrderDetail(params) {
  return Http.get(`${prefix}/photo/task/app/get/detail`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 根据车源编号获取工单
 * @param {number} id 车源编号/vin码后6位
 * @returns object
 */
export function getWholesalOrder(params) {
  return Http.get(`${prefix}/photo/task/app/query/by/id`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 手动创建拍摄任务
 * @param {number} car_id 车辆ID
 * @returns success
 */
export function createWorkerOrder(params) {
  return Http.post(`${prefix}/photo/task/app/create_work_order`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * 删除拍摄工单
 * @param {number} photo_work_order_id 拍摄工单ID
 * @returns true
 */
export function deleteTask(params) {
  return Http.put(`${prefix}/photo/task/app/delete`, params, {
    isAutoMsg: true,
    isLoading: true
  })
}

/**
 * @description: app-触发手续按钮判断应跳转页面
 */
export function getCarSkipPage (params) {
  return Http.get(`${prefix}/stock/app/car_appendage/skip_page`, params)
}

/**
 * @description: app-手续确认入库前查询库存信息接口
 */
export function fetchInStockInfo (params) {
  return Http.get(`${prefix}/stock/app/car_appendage/in_stock/stock_info/v1`, params)
}

/**
 * @description: app-手续确认入库接口
 */
export function inStockCommit (params) {
  return Http.post(`${prefix}/stock/app/car_appendage/in_stock/commit/v1`, params)
}

/**
 * @description: app-手续确认出库前查询库存信息接口
 */
export function fetchOutStockInfo (params) {
  return Http.get(`${prefix}/stock/app/car_appendage/out_stock/stock_info/v1`, params)
}

/**
 * @description: app-手续确认出库接口
 */
export function outStockCommit (params) {
  return Http.post(`${prefix}/stock/app/car_appendage/out_stock/commit/v1`, params)
}

/**
 * @description: app-手续在库查询库存信息接口
 */
export function fetchRemainStockInfo (params) {
  return Http.get(`${prefix}/stock/app/car_appendage/remain/stock_info/v1`, params)
}

/**
 * @description: app-手续在库资料修改提交接口
 */
export function remainStockCommit (params) {
  return Http.post(`${prefix}/stock/app/car_appendage/remain/commit/v1`, params)
}

/**
 * @description: app-手续已出库查询库存信息接口
 */
export function fetchLeavedStockInfo (params) {
  return Http.get(`${prefix}/stock/app/car_appendage/leaved/stock_info/v1`, params)
}

/**
 * @description: app-库存调拨单列表接口
 */
export function fetchTransferStockList (params) {
  return Http.post(`${prefix}/stock/app/kd/transfer/list/v1`, params)
}

/**
 * @description: app-出库任务列表接口
 */
export function fetchOutStockList (params) {
  return Http.post(`${prefix}/stock/app/kd/out_stock_task/list/v1`, params)
}

/** ======================= 灰度 ======================= */
/**
 * 判断当前登录人所在门店是否是灰度门店
 * @param {*} params 
 * @returns 
 */
export function getShopGrayStatus () {
  return Http.get(`${prefix}/stock/app/judge_shop`)
}

/**
 * 查询列表接口v2
 * @param {*} params 
 * @returns 
 */
export function getStockListV2 (params) {
  return Http.post(`${prefix}/stock/app/stock_list/v2`, params)
}

/**
 * 库存详情查询v3
 * @param {*} params 
 * @returns 
 */
export function getStockDetailV3 (params) {
  return Http.get(`${prefix}/stock/app/stock_detail/v3`, params)
}

/**
 * 查询vin码明文接口
 * @param {*} params 
 * @returns 
 */
export function getStockCarVin (params) {
  return Http.get(`${prefix}/stock/app/get_car_vin`, params)
}

/**
 * 查询车牌号码明文接口
 * @param {*} params 
 * @returns 
 */
export function getStockCarPlateNumber (params) {
  return Http.get(`${prefix}/stock/app/get_plate_number`, params)
}

/**
 * 根据stock_id查询库存记录列表
 * @param {*} params 
 * @returns 
 */
export function getStockHistory (params) {
  return Http.get(`${prefix}/stock/app/stock_history/v2`, params)
}

/**
 * 根据stock_id查询库存记录列表
 * @param {*} params 
 * @returns 
 */
export function updateStockDetailV3 (params) {
  return Http.post(`${prefix}/stock/app/update_stock_detail/v3`, params)
}

/**
 * 查看图片记录相关敏感信息
 * @param {*} params 
 * @returns 
 */
export function stockMarkPhoto (params) {
  return Http.get(`${prefix}/stock/app/mark_photo`, params)
}
